import { useState, useEffect, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { useDemoRequest } from "../../../components/feature/DemoRequest";

interface Slide {
  image: string;
  headline: string;
  subtext: string;
  cta: { label: string; href: string };
  hasDemoCta?: boolean;
}

const slides: Slide[] = [
  {
    image: "https://readdy.ai/api/search-image?query=A%20bright%20naturally%20lit%20Nigerian%20office%20environment%20with%20African%20professionals%20working%20productively%20at%20modern%20desks%2C%20organized%20paperwork%20and%20laptops%20open%20with%20business%20applications%20visible%2C%20warm%20sunlight%20streaming%20through%20large%20windows%20creating%20a%20pleasant%20productive%20atmosphere%2C%20people%20collaborating%20and%20focused%2C%20clean%20contemporary%20workspace%20with%20green%20plants%2C%20the%20scene%20shows%20a%20company%20that%20has%20upgraded%20from%20chaos%20to%20structure%2C%20professional%20corporate%20photography%20with%20balanced%20warm%20lighting%2C%20no%20visible%20text%20or%20logos%2C%20ultra%20high%20resolution%204K%20quality&width=1920&height=1080&seq=hero-slide-1-v2&orientation=landscape",
    headline: "Your business has outgrown its tools.",
    subtext: "It's time for real infrastructure.",
    cta: { label: "See the platform", href: "/products" },
  },
  {
    image: "https://readdy.ai/api/search-image?query=A%20bright%20modern%20open%20plan%20office%20workspace%20with%20three%20large%20monitors%20on%20a%20clean%20white%20desk%20showing%20a%20unified%20business%20software%20platform%2C%20the%20left%20screen%20displays%20a%20project%20management%20kanban%20board%20with%20colorful%20task%20cards%2C%20the%20center%20screen%20shows%20a%20people%20directory%20with%20employee%20profile%20photos%2C%20the%20right%20screen%20shows%20analytics%20charts%20and%20bar%20graphs%2C%20all%20within%20one%20cohesive%20interface%20with%20a%20shared%20sidebar%2C%20a%20Black%20African%20professional%20woman%20typing%20at%20the%20keyboard%20in%20the%20foreground%20wearing%20a%20light%20blue%20shirt%2C%20abundant%20natural%20daylight%20streaming%20through%20large%20windows%2C%20warm%20and%20inviting%20office%20atmosphere%20with%20green%20plants%20visible%2C%20the%20screens%20are%20bright%20and%20readable%2C%20professional%20corporate%20photography%20with%20balanced%20lighting%2C%20no%20readable%20text%20or%20logos%20on%20interfaces%2C%20ultra%20high%20resolution%204K%20quality&width=1920&height=1080&seq=hero-slide-2-v4&orientation=landscape",
    headline: "Eleven apps. One operating system.",
    subtext: "Start with one. Run your entire business on all of them.",
    cta: { label: "Explore the platform", href: "/products" },
  },
  {
    image: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Lagos%20Nigeria%20business%20district%20with%20modern%20skyscrapers%20and%20urban%20infrastructure%2C%20recognizable%20Nigerian%20urban%20environment%2C%20proud%20and%20local%20feeling%2C%20golden%20hour%20lighting%2C%20dramatic%20clouds%2C%20cityscape%20photography%2C%20desaturated%20dark%20tones%2C%20professional%20aerial%20drone%20photography%2C%20no%20visible%20text%20or%20logos%2C%20high%20resolution&width=1920&height=1080&seq=hero-slide-3&orientation=landscape",
    headline: "Built in Nigeria. Built for how you actually work.",
    subtext: "Naira pricing. Local compliance. No foreign software guesswork.",
    cta: { label: "Our story", href: "/about" },
  },
  {
    image: "https://readdy.ai/api/search-image?query=A%20Nigerian%20operations%20manager%20with%20dark%20skin%20wearing%20a%20branded%20polo%20shirt%20standing%20in%20a%20busy%20production%20facility%2C%20holding%20a%20tablet%20that%20displays%20a%20live%20operations%20dashboard%20with%20metrics%20and%20charts%20glowing%20on%20the%20screen%2C%20workers%20and%20machinery%20active%20in%20the%20background%2C%20the%20tablet%20screen%20is%20clearly%20visible%20and%20bright%20showing%20real-time%20data%2C%20industrial%20environment%20with%20conveyor%20belts%20and%20equipment%2C%20warm%20overhead%20lighting%2C%20the%20scene%20conveys%20software%20being%20used%20in%20a%20real%20working%20business%2C%20documentary%20corporate%20photography%20style%2C%20no%20readable%20text%20or%20logos%20on%20signage%2C%20ultra%20high%20resolution%204K%20quality&width=1920&height=1080&seq=hero-slide-4-v2&orientation=landscape",
    headline: "Not theory. Proven in production.",
    subtext: "Every app was built and tested inside a live operating business.",
    cta: { label: "See what's included", href: "/products" },
  },
  {
    image: "https://readdy.ai/api/search-image?query=A%20confident%20Black%20African%20female%20CEO%20sitting%20at%20a%20wide%20executive%20desk%20in%20a%20premium%20modern%20office%2C%20actively%20working%20on%20a%20laptop%20that%20displays%20a%20clean%20dark-themed%20business%20dashboard%20with%20charts%20and%20metrics%20glowing%20on%20screen%2C%20she%20is%20leaning%20forward%20engaged%20and%20in%20control%2C%20wearing%20a%20sharp%20white%20blazer%2C%20desk%20has%20a%20notebook%2C%20coffee%20cup%2C%20and%20phone%20neatly%20arranged%20showing%20organized%20workflow%2C%20warm%20natural%20light%20from%20large%20windows%2C%20Lagos%20cityscape%20visible%20in%20background%2C%20the%20scene%20conveys%20someone%20who%20has%20mastered%20their%20business%20operations%2C%20professional%20corporate%20photography%2C%20no%20readable%20text%20or%20logos%2C%20ultra%20high%20resolution%204K%20quality&width=1920&height=1080&seq=hero-slide-5-v3&orientation=landscape",
    headline: "Ready to run your business like a system?",
    subtext: "A team that sets you up and stays with you.",
    cta: { label: "Start free trial", href: "/pricing" },
    hasDemoCta: true,
  },
  {
    image: "https://public.readdy.ai/ai/img_res/edited_76975f3ae6d6ec9bfc29268a577324e8_21174e84.jpg",
    headline: "The Future of Fitness Management Is Here",
    subtext: "Member management, class scheduling, and billing — all in one platform built for fitness operators.",
    cta: { label: "Explore Get Fit", href: "/products/get-fit" },
  },
];

export default function HeroSection() {
  const [active, setActive] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const touchStartX = useRef<number | null>(null);
  const { open } = useDemoRequest();

  const next = useCallback(
    () => setActive((prev) => (prev + 1) % slides.length),
    []
  );
  const prev = useCallback(
    () => setActive((p) => (p - 1 + slides.length) % slides.length),
    []
  );

  useEffect(() => {
    if (isPaused) return;
    const id = setInterval(next, 5500);
    return () => clearInterval(id);
  }, [next, isPaused]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [prev, next]);

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStartX.current === null) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) next();
      else prev();
    }
    touchStartX.current = null;
  };

  return (
    <section
      className="relative flex items-end overflow-hidden bg-graphite-900 min-h-[520px] md:min-h-[600px] lg:min-h-screen select-none"
      aria-roledescription="carousel"
      aria-label="StackMap Systems featured solutions"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {/* Background images */}
      <div className="absolute inset-0 w-full h-full">
        {slides.map((slide, i) => (
          <div
            key={i}
            className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${
              i === active ? "opacity-100 z-[1]" : "opacity-0 z-0"
            }`}
            aria-hidden={i !== active}
          >
            <img
              alt=""
              className="w-full h-full object-cover object-top"
              loading={i === 0 ? "eager" : "lazy"}
              src={slide.image}
            />
          </div>
        ))}
      </div>

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-black/60 z-[2]" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/30 z-[2]" />

      {/* Content */}
      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 xl:px-16 py-20 md:py-28 pt-24 md:pt-32">
        <div className="max-w-6xl mx-auto">
          <div key={active} className="max-w-[680px] text-center md:text-left">
            <h1 className="carousel-headline text-[28px] sm:text-[32px] md:text-[48px] lg:text-[56px] font-bold text-white leading-tight tracking-tight mb-4 md:mb-6">
              {slides[active].headline}
            </h1>
            <p className="carousel-subtext text-[15px] sm:text-base md:text-lg lg:text-xl text-gray-300 max-w-xl mx-auto md:mx-0 leading-relaxed mb-6 md:mb-8">
              {slides[active].subtext}
            </p>
            <div className="carousel-cta flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3 md:gap-4">
              <Link
                to={slides[active].cta.href}
                className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-7 py-3 bg-emerald-accent text-white font-semibold text-sm rounded-lg transition-colors duration-200 hover:bg-emerald-hover whitespace-nowrap"
              >
                {slides[active].cta.label}
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm" />
                </span>
              </Link>
              {slides[active].hasDemoCta && (
                <button
                  onClick={open}
                  className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-7 py-3 bg-transparent border border-white/60 text-white font-semibold text-sm rounded-lg transition-all duration-200 hover:bg-white/5 hover:border-white whitespace-nowrap cursor-pointer"
                >
                  Book a demo
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Arrow navigation */}
      <button
        className="hidden md:flex absolute left-4 lg:left-8 top-1/2 -translate-y-1/2 z-10 w-12 h-12 items-center justify-center rounded-full bg-black/40 backdrop-blur-sm border border-white/10 text-white/80 hover:bg-emerald-accent/30 hover:text-white transition-all duration-300 cursor-pointer"
        aria-label="Previous slide"
        onClick={prev}
      >
        <span className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-left-s-line text-lg" />
        </span>
      </button>
      <button
        className="hidden md:flex absolute right-4 lg:right-8 top-1/2 -translate-y-1/2 z-10 w-12 h-12 items-center justify-center rounded-full bg-black/40 backdrop-blur-sm border border-white/10 text-white/80 hover:bg-emerald-accent/30 hover:text-white transition-all duration-300 cursor-pointer"
        aria-label="Next slide"
        onClick={next}
      >
        <span className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-right-s-line text-lg" />
        </span>
      </button>

      {/* Dot indicators */}
      <div className="absolute bottom-6 md:bottom-10 left-1/2 -translate-x-1/2 z-10 flex items-center gap-2">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setActive(i)}
            className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
              i === active
                ? "w-6 bg-emerald-accent"
                : "w-2 bg-gray-600 hover:bg-gray-500"
            }`}
            aria-label={`Go to slide ${i + 1}`}
            aria-current={i === active ? "true" : undefined}
          />
        ))}
      </div>

      {/* Slide counter */}
      <div className="hidden md:flex absolute bottom-10 right-8 z-10 items-center gap-2 text-white/40 text-sm font-medium">
        <span className="text-white font-bold tabular-nums">
          0{active + 1}
        </span>
        <span className="w-6 h-px bg-white/30" />
        <span className="tabular-nums">0{slides.length}</span>
      </div>
    </section>
  );
}